import { layoutConfig } from '@/../themeConfig.js';

import '@layouts/styles/index.scss';

import { createLayouts } from '@/@layouts';

// ℹ️ We generate layout config from our themeConfig so you don't have to write config twice
export default createLayouts(layoutConfig);
